<template>
    <div>
        <v-card>
            <logs-and-data-tabs current-tab="SystemEmails" />
            <v-toolbar flat color="white" class="mt-4">
                <v-toolbar-title>System Emails</v-toolbar-title>
                <v-spacer />
                <search-filter v-model="keywordSearch" />
            </v-toolbar>
            <v-divider></v-divider>
            <v-toolbar flat color="white" class="mt-4">
                <v-toolbar-title>Export Emails</v-toolbar-title>
                <v-spacer />
                <v-menu v-model="fromDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field label="From Date"
                                      prepend-icon="event"
                                      readonly
                                      :value="fromDateDisp"
                                      v-on="on"></v-text-field>
                    </template>
                    <v-date-picker locale="en-in"
                                   :min="minDate"
                                   :max="maxDate"
                                   v-model="fromDateVal"
                                   no-title
                                   @input="fromDateMenu = false"></v-date-picker>
                </v-menu>
                <v-menu v-model="toDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field label="To Date"
                                      prepend-icon="event"
                                      readonly
                                      :value="toDateDisp"
                                      v-on="on"></v-text-field>
                    </template>
                    <v-date-picker locale="en-in"
                                   :min="minDate"
                                   :max="maxDate"
                                   v-model="toDateVal"
                                   no-title
                                   @input="toDateMenu = false"></v-date-picker>
                </v-menu>
                <v-select v-model="subjectExportFilter" :items="subjects" :loading="exportToolbarLoading" label="Subject" item-value="id" style="margin-right: 16px; margin-left: 28px"/>
                <v-btn color="danger" type="submit" @click="exportAuthorRequests()" :loading="authorRequestsLoading">
                    Export to Excel
                </v-btn>
            </v-toolbar>
            <v-data-table :headers="headers" :items="systemEmails" :pagination.sync="pagination" :total-items="totalRecords" :loading="loading" :rows-per-page-items="rowsPerPageItems">
                <v-progress-linear slot="progress" color="secondary" indeterminate />
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.sendDateTime | formatDate }}</td>
                    <td>{{ props.item.fromAddress }}</td>
                    <td>{{ props.item.toAddress }}</td>
                    <td>{{ props.item.subject }}</td>
                    <td>
                        <v-icon class="mr-3" @click="viewEmail(props.item)">
                            far fa-envelope
                        </v-icon>
                    </td>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-text>
                    <v-container>
                        <div v-html="emailHtml" />
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn flat @click.native="dialog=false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import _ from 'lodash';
    import axios from 'axios';
    import localforage from 'localforage';
    import LogsAndDataTabs from './components/LogsAndDataTabs.vue';
    import dayjs from 'dayjs';

    export default {
        parent: true,

        components: {
            LogsAndDataTabs,
        },

        data: () => ({
            loading: true,
            dialog: false,
            systemEmails: [],
            totalRecords: 0,
            rowsPerPageItems: [20, 50, 75, 100],
            emailHtml: '',
            pagination: {
                descending: true, page: 1, rowsPerPage: 20, sortBy: 'SendDateTime', totalItems: 0,
            },
            headers: [
                {
                    text: 'Sent Date Time', value: 'sendDateTime', align: 'left', sortable: true,
                },
                {
                    text: 'From', value: 'fromAddress', align: 'left', sortable: true,
                },
                {
                    text: 'To', value: 'toAddress', align: 'left', sortable: true,
                },
                {
                    text: 'Subject', value: 'subject', align: 'left', sortable: true,
                },
                {
                    text: 'View Email', value: '', align: 'left', sortable: false,
                },
            ],
            exportFilter: ["New Author", "Other", "Other2"],
            keywordSearch: '',
            authorRequestFromDate: '',
            authorRequestToDate: '',
            authorRequestsLoading: false,
            fromDateMenu: false,
            fromDateVal: null,
            toDateMenu: false,
            toDateVal: null,
            exportToolbarLoading: true,
            formattedFromDate: '',
            formattedToDate: '',
            subjectExportFilter: '',
            subjects: [],

            minDate: "2015-06-01",
            maxDate: "2080-01-30"
        }),

        computed: {
            fromDateDisp() {
                return this.fromDateVal;
                // format date, apply validations, etc. Example below.
                // return this.fromDateVal ? this.formatDate(this.fromDateVal) : "";
            },
            toDateDisp() {
                return this.toDateVal;
                // format date, apply validations, etc. Example below.
                // return this.fromDateVal ? this.formatDate(this.fromDateVal) : "";
            }
        },
        watch: {
            pagination: {
                handler(newval, oldval) {
                    if (!_.isEqual(newval, oldval)) {
                        this.getEmails();
                    }
                },
                deep: true,
            },

            'pagination.rowsPerPage': function (val) {
                localforage.setItem('SystemEmailsGrid:RowsPerPage', val);
            },

            keywordSearch() {
                this.processSearch();
            },
        },

        mounted() {
            localforage.getItem('SystemEmailsGrid:RowsPerPage').then((value) => {
                this.pagination.rowsPerPage = value || 20;
                this.getEmails();
                this.getSubjects();
            });
        },

        methods: {
            async getSubjects() {
                const { data } = await axios.get(`/api/emails/subjects`);
                this.subjects = data;
                this.exportToolbarLoading = false;
            },
            async getEmails() {
                const {
                    sortBy, descending, page, rowsPerPage,
                } = this.pagination;
                const sortDirection = descending ? `${sortBy} DESC` : `${sortBy} ASC`;
                this.loading = true;
                const { data } = await axios.get(`/api/emails/paged?currentPage=${page}&pageSize=${rowsPerPage}&sortDir=${sortDirection}&filter=${this.keywordSearch}`);
                this.systemEmails = data.resultItems;
                this.totalRecords = data.totalRecords;
                this.loading = false;
            },
            viewEmail(item) {
                this.emailHtml = item.body;
                this.dialog = true;
            },

            processSearch: _.debounce(function () {
                this.getEmails();
            }, 600),

            async exportAuthorRequests() {
                this.authorRequestsLoading = true;
                if (this.fromDateVal != null) {
                    this.formattedFromDate = dayjs(this.fromDateVal).format('MM/DD/YYYY');
                }
                else {
                    this.formattedFromDate = dayjs('2015/06/01').format('MM/DD/YYYY');
                }
                if (this.toDateVal != null) {
                    this.formattedToDate = dayjs(this.toDateVal).format('MM/DD/YYYY');            
                }
                else {
                    this.formattedToDate = dayjs('2085/06/01').format('MM/DD/YYYY');
                }

                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                today = mm + '-' + dd + '-' + yyyy;

                const { data } = await axios.get(`/api/emails/excel-export?fromDate=${this.formattedFromDate}&toDate=${this.formattedToDate}&subject=${this.subjectExportFilter}`, {
                    responseType: 'blob',
                });
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'system-emails-' + today +'.xlsx');
                document.body.appendChild(link);
                link.click();
                this.authorRequestsLoading = false;
            }
        }
    }
    
</script>
